import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import {
  UserContextEnum,
  UserContextService,
} from '../services/user-context.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserHasContextGuard implements CanActivate {
  constructor(
    private userContextService: UserContextService,
    private router: Router
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const userContext = this.userContextService.getCurrentUserContext();

    if (userContext === UserContextEnum.Unset) {
      // Redirect to home as context should be automatically set upon login
      return this.router.createUrlTree(['/profile']);
    }
    return true;
  }
}
